import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet, isBackendConfigured } from '../utils/backendApi';
import { BugStatusChip } from './MyBugs';

// /admin/bugs — the super admin's queue (GET /bugs, operator-gated). Each
// row opens /admin/bugs/:id where the fix is proposed, built and promoted.
const FILTERS = [
  ['open', 'Open'],
  ['new', 'New'],
  ['fixing', 'Fixing'],
  ['pr', 'PR ready'],
  ['uat', 'On UAT'],
  ['shipped', 'Shipped'],
  ['closed', 'Closed'],
  ['all', 'All'],
];

function when(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString();
}

export default function AdminBugs() {
  const [filter, setFilter] = useState('open');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isBackendConfigured()) { setError('The API is not configured.'); return undefined; }
    let stop = false;
    const q = filter === 'open' || filter === 'all' ? '' : `?status=${filter}`;
    apiGet(`/bugs${q}`).then((d) => { if (!stop) { setData(d); setError(''); } }).catch((err) => { if (!stop) setError(err.message); });
    return () => { stop = true; };
  }, [filter]);

  const bugs = (data?.bugs || []).filter((b) => (filter === 'open' ? !['shipped', 'closed'].includes(b.status) : true));

  return (
    <div className="cs-store">
      <header className="cs-store-hero">
        <h1>Bug reports</h1>
        <p>
          Reported from the console by members of every organization. New reports are mailed to {data?.notifyTo || '…'}.
          Open one to propose a fix with the Cursor agent on <span className="aa-mono">{data?.repo || '…'}</span>, merge &amp; build to UAT, then approve &amp; promote.
        </p>
      </header>
      <section className="cs-store-section cs-support-desk">
        <div className="cs-sw-card">
          <div className="bug-list-head">
            <h3>Queue</h3>
            <Link to="/admin/apps" className="cs-help">Releases tab →</Link>
          </div>
          <div className="bug-queue-filters" role="tablist" aria-label="Filter">
            {FILTERS.map(([id, label]) => (
              <button key={id} type="button" role="tab" aria-selected={filter === id} className={filter === id ? 'is-on' : ''} onClick={() => setFilter(id)}>{label}</button>
            ))}
          </div>
          {error && <p className="cs-land-micro" role="alert">{error}</p>}
          {!data && !error && <p className="cs-help">Loading…</p>}
          {data && bugs.length === 0 && <p className="cs-help">Nothing here.</p>}
          <ul className="cs-support-list">
            {bugs.map((b) => (
              <li key={b.id}>
                <Link to={`/admin/bugs/${b.id}`} className="cs-support-row bug-row" style={{ display: 'flex', textDecoration: 'none' }}>
                  <div className="bug-row-top">
                    <strong>{b.title || 'Bug report'}</strong>
                    <BugStatusChip status={b.status} />
                  </div>
                  <span className="cs-help">
                    {b.name || b.email}{b.orgName ? ` · ${b.orgName}` : ''} · {when(b.createdAt)}
                    {b.context?.route ? ` · ${b.context.route}` : ''}
                    {b.attachments?.length ? ` · ${b.attachments.length} file${b.attachments.length === 1 ? '' : 's'}` : ''}
                    {b.fix?.prUrl ? ` · PR #${b.fix.prNumber || ''}` : ''}
                    {b.fix?.status === 'running' || b.fix?.status === 'starting' ? ' · agent working' : ''}
                    {b.fix?.lastError ? ' · agent error' : ''}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
